import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router";
import { SlOption, SlSelect, SlTab, SlTabGroup, SlTabPanel, SlIcon, SlIconButton, SlTooltip, SlDrawer } from '@shoelace-style/shoelace/dist/react';
import LineItemsTableView from './LineItemsTableView'
import { CSVLink } from "react-csv";
import TableLoader from "../../shared/TableLoader";
import filterSvg from "../../assets/images/filter.svg";
import { useDispatch, useSelector } from 'react-redux';
import { formatDateDDMMYYY, formatDateWithTime, formatDateWithTimeYear } from "../../utils/dateFormat";
import { Toast } from "../../shared/Toast";
import api from "../../services/api"
import NoDataFound from "../../shared/NoDataFound";
import { roles, languageOptions, stateOptions,teams, BrandsTypes} from "../../utils/constants";
import API from "../../services/api";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import { SetCampCount, SetComponentId } from '../../redux/counterSlice'
import CryptoJS from 'crypto-js';

function LineItems() {
    const dispatch = useDispatch()
    dispatch(SetComponentId(3))
    function handleRequestClose(event) {
        if (event.detail.source === "overlay") {
          event.preventDefault();
        }
      }
    const [filter_sales_ops, setFiltersales_ops] = useState({ index: -1, value: -1 })

    const [search, setSearch] = useState("");
    const [campaignType, setCampaignType] = useState("all");
    const [x_filter, setX_filter] = useState(0)
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [activeTab, setActiveTab] = useState('sales')
    const [langfilter, setLangFilter] = useState(-1)
    const [initialRender, setInitialRender] = useState(true);
    const HeaderSearch = useSelector(state => state.Head.adssearch)
    const Headdate = useSelector(state => state.Head.date)
    const SALES = useSelector(state => state.Head.opssales)
    const lineItemsFlag = useSelector(state => state.Head.lineItemsFlag)
    const lineItemStatus = useSelector(state => state.Head.LIstatus)
    const [status_filter, setStatus_filter] = useState(-1)

    const [statefilter, setStatefilter] = useState(-1)
    const [districtselect, setSelectdistrict] = useState(-1)
    const [districtfilter, setDistrictfilter] = useState([])
    const [mandalfilter, setMandalfilter] = useState([])
    const [target_filter, setTarget_filter] = useState({})
    const [headViewData, setHeadViewData] = useState({})
    const [headViewMonthFlag, setHeadViewMonthFlag] = useState("")
    const [downloadLoader, setDownloadLoader] = useState(false);
    const [downloadData, setDownloadData] = useState([]);
    const csvLinkRef = useRef(); // Create a ref for CSVLink
    const [showFilter, setShowFilter] = useState(false)
    const [currentTab, setCurrentTab] = useState("sales");
    const [orderByCName, setOrderByCName] = useState(0);

    const [salesTeam,setSalesTeam]=useState("All");
    const [salesCategory,setSalesCategory]=useState("0");

    const handleTabClick = (tabName) => {
        setCurrentTab(tabName);
    };
    let salesUserType = ""
    if (localStorage.getItem('role') === roles.salesperson && localStorage.getItem('salesTabFlag')) {
        const decryptedSalesTabPermissions = CryptoJS.AES.decrypt(localStorage.getItem('salesTabFlag'), config.B2B_SECRET_KEY);
        salesUserType = decryptedSalesTabPermissions.toString(CryptoJS.enc.Utf8)
    }
    
    const navigate = useNavigate()
    const result = {
        type: "",
        action: "add",
        datavariable: []
    }
    useEffect(() => {
        const role = localStorage.getItem("role");
        if (role !== roles.ops && role !== roles.financer)
          navigate("/pagenotfound");
      }, []);

    // useEffect(() => {
    //     getSalesStats()
    // }, [])

    useEffect(() => {
        if (localStorage.getItem("role") === roles.financer) {
            setActiveTab("all")
        }
        if (activeTab === "sales") {
            return
        }
        else {
            changeSALES_OPS()
        }
    }, [SALES?.index])


    useEffect(()=>{
        if(!initialRender)
            getData(search, currentPage, status_filter, campaignType, filter_sales_ops, x_filter, target_filter,salesTeam,salesCategory,"1")
    },[lineItemsFlag])

    useEffect(() => {
        HandleHeaderSearch()
    }, [HeaderSearch])

    useEffect(() => {
        changeDateHandler()
    }, [Headdate])

    useEffect(() => {
        lineItemStatusHandler()
    }, [lineItemStatus])
    useEffect(() => {
        if(!initialRender){
            getData(search, 0, status_filter, campaignType, filter_sales_ops, x_filter,  target_filter,salesTeam,salesCategory,"17");
        }
    }, [orderByCName])

    const lineItemStatusHandler = () => {
        if (!initialRender) {
            setStatus_filter(lineItemStatus)
            setCurrentPage(0);
            getData(search, 0, lineItemStatus, campaignType, filter_sales_ops, x_filter,  target_filter,salesTeam,salesCategory,"6");
        }
    }
   
    const downloadCreative = async(search = '', page = 0, status = lineItemStatus, campaignType = 'all', sales_ops = { index: -1, value: -1 }, x_filter = 0, target_filter = { lang_id: -1, state_id: -1, district_id: -1, mandal_id: -1 },salesteam="All",salescategory="0",callFlag = '0')=>{
        let res;
        try{
           res= await API({
            url:"/lineitems/CreativeDownload",
            method:'POST',
            responseType:'json',
            data:{
                search,
                page,
                status,
                dateFilter: Headdate,
                campaignType,
                sales_ops,
                x_filter,
                limit: config.PER_PAGE,
                flag: "campaign",
                target_filter,
                sales_team: salesteam,
                sales_category:salescategory
            }
           })
           
           Toast('success',"download request sent, you can download in Creative Previews in a minute")
        }
        catch(error){
            Toast('error', res?.data?.message || "some error occured, try again");
            console.error(error);
        }
    }

    const [categories,setCategories]=useState([]);
    useEffect(()=>{
        getcategories();
    },[])

    useEffect(()=>{
        getcategories();
    },[])

    const getcategories = async () => {
        try {
          let res = await API({
            url:"/plansummary/categories",
            method:'POST',
            responseType:'json',
            data:{}
          })
          if(res.code === 200){
            setCategories(res.data)
          }
        } catch (error) {
          console.error(error);
        }
      }

    const getData = async (search = '', page = 0, status = lineItemStatus, campaignType = 'all', sales_ops = { index: -1, value: -1 }, x_filter = 0, target_filter = { lang_id: -1, state_id: -1, district_id: -1, mandal_id: -1 },salesTeam="All",salesCategory="0",callFlag = '0') => {
        try {
            setLoader(true);
            let res = await api({
                url: '/lineitems/get',
                method: 'POST',
                responseType: 'json',
                data: {
                    search,
                    page,
                    status,
                    dateFilter: Headdate,
                    campaignType,
                    sales_ops,
                    x_filter,
                    limit: config.PER_PAGE,
                    flag: "campaign",
                    target_filter,
                    sales_team: salesTeam,
                    sales_category:salesCategory,
                    orderByCName: orderByCName || 0
                }
            });
            if (res.code === 200) {
                setData(res.data.data);
                setTotalPages(Math.ceil(parseInt(res.data.total) / config.PER_PAGE));
                // setSpent(res.data.spent)
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }
    }

    // const getSalesStats = async () => {
    //     if (localStorage.getItem("role") === roles.salesperson) {
    //         try {
    //             let res = await api({
    //                 url: '/lineitems/getSalesStats',
    //                 method: 'POST',
    //                 responseType: 'json',
    //             })
    //             setSalesTable(res.data);
    //         } catch (error) {
    //             console.error(error);
    //             if (error.response.status === 401)
    //                 navigate("/")
    //         }
    //     }
    // }

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        getData(search, event.selected, status_filter, campaignType, filter_sales_ops, x_filter,  target_filter,salesTeam,salesCategory,"5")
    };
    const handleTabActivate = (event) => {
        setActiveTab(event.detail.name)
        if (event.detail.name === "all") {
            setFiltersales_ops(SALES === "" || SALES.index === -1 || SALES.index === undefined ? { index: 0, value: 0 } : SALES)
            dispatch(SetCampCount(SALES === "" || SALES.index === -1 || SALES.index === undefined ? { index: 0, value: 0 } : SALES))
            setCurrentPage(0);
            getData(search, 0, lineItemStatus, campaignType, SALES === "" || SALES.index === -1 || SALES.index === undefined ? { index: 0, value: 0 } : SALES, x_filter, target_filter,salesTeam,salesCategory,"7");
        }
        else {
            dispatch(SetCampCount({ index: -1, value: -1 }))
            setFiltersales_ops({ index: -1, value: -1 })
            setCurrentPage(0);
            getData(search, 0, lineItemStatus, campaignType, { index: -1, value: -1 }, x_filter, target_filter,salesTeam,salesCategory,"8");
        }
        
    }
    const typeFilterChange = (e) => {
        if (parseInt(e.target.value))
            return
        setCampaignType(e.target.value);
        setCurrentPage(0);
        getData(search, 0, status_filter, e.target.value, filter_sales_ops, x_filter, target_filter,salesTeam,salesCategory,"10");
    }

    const changeSALES_OPS = () => {
        dispatch(SetCampCount(SALES))
        setFiltersales_ops(SALES)
        setCurrentPage(0);
        if (activeTab === "sales") {
            if (!initialRender) {
                getData(search, 0, status_filter, campaignType, SALES, x_filter, target_filter,salesTeam,salesCategory,"11");
            }
        }
        else {
            if (!initialRender) {
                getData(search, 0, status_filter, campaignType, SALES === '' || SALES.index === -1 ? { index: 0, value: 0 } : SALES, x_filter, target_filter,salesTeam,salesCategory,"12");
            }
        }

    }

    const changeDateHandler = () => {
        setCurrentPage(0);
        if (!initialRender) {
            getData(search, 0, status_filter, campaignType, filter_sales_ops, x_filter, target_filter,salesTeam,salesCategory, "13");
        }
    }

    const HandleHeaderSearch = () => {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        if (activeTab === "all") {
            if (!initialRender) {
                getData(HeaderSearch, 0, status_filter, campaignType, filter_sales_ops, x_filter, target_filter,salesTeam,salesCategory,"14");
            }
        }
        else {
            if (!initialRender) {
                getData(HeaderSearch, 0, status_filter, campaignType, filter_sales_ops, x_filter, target_filter,salesTeam,salesCategory,"15");
            }
        }
    }

    const xFilterChange = (e) => {
        setX_filter(e.target.value);
        setCurrentPage(0);
        getData(search, 0, status_filter, campaignType, filter_sales_ops, e.target.value, target_filter,salesTeam,salesCategory,"16");
    }
    const salesTeamchange=(e)=>{
        setSalesTeam(e.target.value);
        setCurrentPage(0);
        getData(search, 0, status_filter, campaignType, filter_sales_ops, x_filter,target_filter,e.target.value,salesCategory)
    }
    const salesCategoryChange=(e)=>{
        setSalesCategory(e.target.value);
        setCurrentPage(0);
        getData(search, 0, status_filter, campaignType, filter_sales_ops, x_filter,target_filter,salesTeam,e.target.value)

    }

    const LanguageFilterChange = (e) => {
        setLangFilter(e.target.value)
        setDistrictfilter([])
        setMandalfilter([])
        setCurrentPage(0);
        const selectedOption = languageOptions.find((item) => item.value === +e.target.value);
        setTarget_filter({ lang_id: e.target.value,lang_label:selectedOption.label, state_id: -1, district_id: -1, mandal_id: -1 })
        getData(search, 0, status_filter, campaignType, filter_sales_ops, x_filter, { lang_id: e.target.value, state_id: -1, district_id: -1, mandal_id: -1 },salesTeam,salesCategory,"19");
        if (parseInt(e.target.value) === -1) {
            setStatefilter(-1)
            setLangFilter(-1)
            setSelectdistrict(-1)
        }
    }

    const StateFilterChange = async (value) => {
        setStatefilter(value)
        setMandalfilter([])
        if (parseInt(value) !== -1) {
            try {
                let res = await api({
                    url: '/location/getDistrictsByStateId',
                    method: 'POST',
                    responseType: 'json',
                    data: { states: [value], langs: [langfilter] }
                })
                let districts = []
                for await (let item of res.data) {
                    const temp = { value: item, label: `${item.dist_name}` }
                    districts.push(temp)
                }
                setDistrictfilter(districts)
                const selectedOption = stateOptions.find((item)=>item.state_id === +value)
                setTarget_filter({ lang_id: target_filter.lang_id,lang_label:target_filter.lang_label, state_id: value,state_label:selectedOption.state_name, district_id: -1, mandal_id: -1 })
            } catch (error) {
                console.error(error);
                if (error.response.status === 401)
                    navigate("/")
            }
        }
        if (parseInt(value) === -1) {
            setSelectdistrict(-1)
            setStatefilter(-1)
        }
        getData(search, 0, status_filter, campaignType, filter_sales_ops, x_filter, { lang_id: target_filter.lang_id, state_id: value, district_id: -1, mandal_id: -1 },salesTeam,salesCategory,"20");

    }

    const DistrictFilterChanger = async (value) => {
        setSelectdistrict(value)
        if (parseInt(value) !== -1) {
            try {
                let res = await api({
                    url: '/location/getMandalsnew',
                    method: 'POST',
                    responseType: 'json',
                    data: { districts: [value], langs: [langfilter] }
                })
                let mandals = []
                for await (let item of res.data) {
                    const temp = { value: item, label: `${item.mandal_name}` }
                    mandals.push(temp)
                }
                const selectedOption = districtfilter.find((item)=>item.value.dist_id === +value)
                setMandalfilter(mandals)
                setTarget_filter({ district_id: value,dist_label:selectedOption.value.dist_name, mandal_id: -1, state_id: target_filter.state_id,state_label:target_filter.lang_label, lang_id: target_filter.lang_id,lang_label:target_filter.lang_label })
            } catch (error) {
                console.error(error);
                if (error.response.status === 401)
                    navigate("/")
            }
        }
        if (parseInt(value) === -1) {
            setSelectdistrict(-1)
        }
        getData(search, 0, status_filter, campaignType, filter_sales_ops, x_filter,  { district_id: value, mandal_id: -1, state_id: target_filter.state_id, lang_id: target_filter.lang_id },salesTeam,salesCategory,"21");

    }

    const MandalFilterChange = async (value) => {
        const selectedOption = mandalfilter.find((item)=>item.value.mandal_id===+value);
        setTarget_filter({ ...target_filter, mandal_id: value,mandal_label:selectedOption.value.mandal_name })
        getData(search, 0, status_filter, campaignType, filter_sales_ops, x_filter, { ...target_filter, mandal_id: value },salesTeam,salesCategory);
    }

    const status_filterChange = (e) => {
        setStatus_filter(e.target.value);
        setCurrentPage(0);
        getData(search, 0, +e.target.value, campaignType, filter_sales_ops, x_filter, target_filter,salesTeam,salesCategory);
    }

    useEffect(() => {
        getData()
        dispatch(SetCampCount({ index: -1, value: -1 }))
        // getSalesStats()
        setInitialRender(false)
    }, []);

    const HeadDetailedView = async (flag) => {
        try {
            const HeadViewResult = await api({
                url: "/user/sales_persons/headView",
                method: "POST",
                responseType: "json",
                data: { flag: flag }
            })
            setHeadViewData(HeadViewResult.data)
            setHeadViewMonthFlag(flag === "thisMonth" ? "This Month" : "Last Month")

        } catch (error) {
            console.error(error)
        }
    }

    const fun3 = (type) => {
        switch (type) {
            case 1:
                return "Created";
            case 2:
                return "Running";
            case 3:
                return "Paused";
            case 4:
                return "Completed";
            default:
                return "Scheduled";
        }
    };

    let csvHeaders = [
        { label: "Lineitem Id", key: "campaign_id" },
        { label: 'Order Id', key: 'order_id' },
        { label: "Campaign Name", key: "campaign_name" },
        { label: " Campaign Type", key: "campaign_type" },
        { label: "Brand Name", key: "brand_name"},
        { label: "Customer Name", key: "company_name"},
        { label: "GST No", key: "gst_no"},
        { label: "Brand Category", key: "category_name"},
        { label: "Start Date", key: "start_date" },
        { label: "End Date", key: "end_date" },
        { label: "Position", key: "position" },
        { label: "Total Budget", key: "total_budget" },
        { label: "Daily Budget", key: "daily_budget" },
        { label: "Sales User Type", key: "new_user_type" },
        { label: "package", key: "package"}
    ];
    // { label: 'CTR(%)', key: 'ctr_percent' },
    // { label: 'ECPM/CPD', key: 'ecpm_cpd' },
    csvHeaders.push({ label: "Sales Person", key: "sales_person_name" });
    if (
        localStorage.getItem("role") === roles.ops
    ) {
        csvHeaders.push({ label: "Adv Impressions", key: "adv_total_imp" });
        csvHeaders.push({ label: "Adv Clicks", key: "adv_total_click" });
        csvHeaders.push({ label: "Adv CTR(%)", key: "adv_ctr" });
        csvHeaders.push({ label: "Adv ECPM/CPD", key: "adv_ecpm" });
        csvHeaders.push({ label: "Impressions", key: "total_imp" });
        csvHeaders.push({ label: "Clicks", key: "total_click" });
        csvHeaders.push({ label: "CTR(%)", key: "ctr_percent" });
        csvHeaders.push({ label: "ECPM/CPD", key: "ecpm_cpd" });
        csvHeaders.push({ label: "Location", key: "location_name" });
        csvHeaders.push({ label: "Shares", key: "shares" });
        csvHeaders.push({ label: "Team", key: "team" });
        csvHeaders.push({ label: "Creative Type", key: "creative_type" });
        csvHeaders.push({ label: "Discount Percentage", key: "discount_per" });
        csvHeaders.push({ label: "After Discount", key: "discount_amount" });
        csvHeaders.push({ label: "Actual Price", key: "actual_price" });
    } else {
        csvHeaders.push({ label: "Impressions", key: "total_imp" });
        csvHeaders.push({ label: "Clicks", key: "total_click" });
    }
    csvHeaders.push({ label: "RO File", key: "rofile_url" });
    csvHeaders.push({ label: "Invoice File", key: "invoice_url" });
    csvHeaders.push({ label: "Spent", key: "spent" });
    if(localStorage.getItem("role") === roles.ops)
        csvHeaders.push({ label: "Adv Spent", key: "adv_spent" });
    csvHeaders.push({ label: "Status", key: "status" });
    csvHeaders.push({ label: "Target", key: "target" });
    if((localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.ops) && Headdate?.startDate){
        csvHeaders.push({ label: "Filtered Impressions", key: "filterImps" });
        csvHeaders.push({ label: "Filtered Clicks", key: "filterClicks" });
        csvHeaders.push({ label: "Filtered Spent", key: "filterSpent" });

        if(localStorage.getItem('role') === roles.ops){
            csvHeaders.push({ label: "Filtered Actual Impressions", key: "filterActualImps" });
            csvHeaders.push({ label: "Filtered Actual Clicks", key: "filterActualClicks" });
            csvHeaders.push({ label: "Filtered Actual Spent", key: "filterActualSpent" });
        }
    }
    const downloadReport = async (sales_ops, search = "", status, dateFilter, campaignType = "all", x_filter = 0,
        target_filter = {
            lang_id: -1,
            state_id: -1,
            district_id: -1,
            mandal_id: -1,
        }, currentTab, salesTeam="All",salesCategory="0"
    ) => {
        setDownloadLoader(true);
        try {
            let result = await api({
                url: "/lineitems/lineItemsReportDownload",
                method: "POST",
                responseType: "json",
                data: {
                    sales_ops: filter_sales_ops,
                    search,
                    status,
                    dateFilter,
                    campaignType,
                    x_filter,
                    target_filter,
                    currentTab,
                    sales_team: salesTeam,
                    sales_category:salesCategory
                },
            });
            if (result?.code === 200) {
                setDownloadLoader(false);
                setDownloadData(result.data.data);
            }
        } catch (error) {
            setDownloadLoader(false);
            console.error(error);
            if (error.response.status === 401) navigate("/");
        }
    };

    useEffect(() => {
        if (downloadData.length) {
            csvLinkRef?.current?.link?.click();
            setDownloadData([]);
        }
    }, [downloadData]);
    return (
        <>
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                        {localStorage.getItem("role") === roles.salesperson && <h4 class="mb-sm-0 font-size-18">Dashboard</h4>}
                    </div>
                </div>
            </div>
            <div class="row">
                <div className={
                    "table-responsive col-md-12"}>



                    {/* {//new Dashboard 
                        (localStorage.getItem("role") === roles.salesperson && Object.keys(salesTable).length) ? <table className='table table-bordered table-pad-sm'>

                            <thead className="bg-neutral-50">
                                <tr>
                                    <th></th>
                                    <th>I/O Received</th>
                                    <th>Delivered</th>
                                    <th>Target</th>
                                    <th>achieved</th>
                                    <th>Rank</th>
                                    <th>Campaigns</th>
                                    <th>Avg</th>
                                    {salesUserType && <></>}

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>This Month</td>
                                    <td> {salesTable.ThisMonthRoCPD < salesTable.lastMonthRoCPD ? (
                                        <span style={{ color: 'red' }}>
                                            <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.ThisMonthRoCPD)}`}
                                        </span>
                                    ) : salesTable.ThisMonthRoCPD > salesTable.lastMonthRoCPD ? (
                                        <span style={{ color: 'green' }}>
                                            <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.ThisMonthRoCPD)}`}
                                        </span>
                                    ) : `₹${formatSpentValue(salesTable.ThisMonthRoCPD)}`}</td>
                                    <td>{salesTable.thisMonthDelivered < salesTable.lastMonthDelivered ? (
                                        <span style={{ color: 'red' }}>
                                            <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.thisMonthDelivered)}`}
                                        </span>
                                    ) : salesTable.thisMonthDelivered > salesTable.lastMonthDelivered ? (
                                        <span style={{ color: 'green' }}>
                                            <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.thisMonthDelivered)}`}
                                        </span>
                                    ) : `₹${formatSpentValue(salesTable.thisMonthDelivered)}`}</td>
                                    <td>{salesTable.thisMonthTarget < salesTable.lastMonthTarget ? (
                                        <span style={{ color: 'red' }}>
                                            <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.thisMonthTarget)}`}
                                        </span>
                                    ) : salesTable.thisMonthTarget > salesTable.lastMonthTarget ? (
                                        <span style={{ color: 'green' }}>
                                            <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.thisMonthTarget)}`}
                                        </span>
                                    ) : `₹${formatSpentValue(salesTable.thisMonthTarget)}`}</td>

                                    <td>{salesTable.thisMonthAchieved < salesTable.lastMonthAchieved ? (
                                        <span style={{ color: 'red' }}>
                                            <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.thisMonthAchieved)}`}
                                        </span>
                                    ) : salesTable.thisMonthAchieved > salesTable.lastMonthAchieved ? (
                                        <span style={{ color: 'green' }}>
                                            <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.thisMonthAchieved)}`}
                                        </span>
                                    ) : `₹${formatSpentValue(salesTable.thisMonthAchieved)}`}</td>
                                    <td>{salesTable.ThisMonthRank < salesTable.lastMonthRank ? (
                                        <span style={{ color: 'red' }}>
                                            <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                            {`${(salesTable.ThisMonthRank ? salesTable.ThisMonthRank : '-')}`}
                                        </span>
                                    ) : salesTable.ThisMonthRank > salesTable.lastMonthRank ? (
                                        <span style={{ color: 'green' }}>
                                            <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                            {`${(salesTable.ThisMonthRank ? salesTable.ThisMonthRank : '-')}`}
                                        </span>
                                    ) : `${(salesTable.ThisMonthRank ? salesTable.ThisMonthRank : '-')}`}</td>
                                    <td> {salesTable.ThisMonthCampaignsCount < salesTable.LastMonthCampaignsCount ? (
                                        <span style={{ color: 'red' }}>
                                            <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                            {salesTable.ThisMonthCampaignsCount}
                                        </span>
                                    ) : salesTable.ThisMonthCampaignsCount > salesTable.LastMonthCampaignsCount ? (
                                        <span style={{ color: 'green' }}>
                                            <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                            {salesTable.ThisMonthCampaignsCount}
                                        </span>
                                    ) : salesTable.ThisMonthCampaignsCount}</td>
                                    <td>{salesTable.thisMonthAvg < salesTable.lastMonthAvg ? (
                                        <span style={{ color: 'red' }}>
                                            <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                            {`${(salesTable.thisMonthAvg)}`}
                                        </span>
                                    ) : salesTable.thisMonthAvg > salesTable.lastMonthAvg ? (
                                        <span style={{ color: 'green' }}>
                                            <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                            {`${(salesTable.thisMonthAvg)}`}
                                        </span>
                                    ) : `${(salesTable.thisMonthAvg)}`}</td>
                                    {salesUserType && <td>
                                        <sl-tooltip content="View" hoist>
                                            <sl-icon-button
                                                library="lucide"
                                                name="eye"
                                                style={{ backgroundColor: "transparent" }}
                                                onClick={() => { HeadDetailedView("thisMonth") }}></sl-icon-button>
                                        </sl-tooltip>
                                    </td>}

                                </tr>
                                <tr>
                                    <td>Last Month</td>
                                    <td> {salesTable.lastMonthRoCPD < salesTable.ThisMonthRoCPD ? (
                                        <span style={{ color: 'red' }}>
                                            <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.lastMonthRoCPD)}`}
                                        </span>
                                    ) : salesTable.lastMonthRoCPD > salesTable.ThisMonthRoCPD ? (
                                        <span style={{ color: 'green' }}>
                                            <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                            {`₹${formatSpentValue(salesTable.lastMonthRoCPD)}`}
                                        </span>
                                    ) : `₹${formatSpentValue(salesTable.lastMonthRoCPD)}`}</td>
                                    <td>
                                        {salesTable.lastMonthDelivered < salesTable.thisMonthDelivered ? (
                                            <span style={{ color: 'red' }}>
                                                <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                                {`₹${formatSpentValue(salesTable.lastMonthDelivered)}`}
                                            </span>
                                        ) : salesTable.lastMonthDelivered > salesTable.thisMonthDelivered ? (
                                            <span style={{ color: 'green' }}>
                                                <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                                {`₹${formatSpentValue(salesTable.lastMonthDelivered)}`}
                                            </span>
                                        ) : `₹${formatSpentValue(salesTable.lastMonthDelivered)}`}

                                    </td>
                                    <td>
                                        {salesTable.lastMonthTarget < salesTable.thisMonthTarget ? (
                                            <span style={{ color: 'red' }}>
                                                <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                                {`₹${formatSpentValue(salesTable.lastMonthTarget)}`}
                                            </span>
                                        ) : salesTable.lastMonthTarget > salesTable.thisMonthTarget ? (
                                            <span style={{ color: 'green' }}>
                                                <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                                {`₹${formatSpentValue(salesTable.lastMonthTarget)}`}
                                            </span>
                                        ) : `₹${formatSpentValue(salesTable.lastMonthTarget)}`}

                                    </td>
                                    <td>
                                        {salesTable.lastMonthAchieved < salesTable.thisMonthAchieved ? (
                                            <span style={{ color: 'red' }}>
                                                <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                                {`₹${formatSpentValue(salesTable.lastMonthAchieved)}`}
                                            </span>
                                        ) : salesTable.lastMonthAchieved > salesTable.thisMonthAchieved ? (
                                            <span style={{ color: 'green' }}>
                                                <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                                {`₹${formatSpentValue(salesTable.lastMonthAchieved)}`}
                                            </span>
                                        ) : `₹${formatSpentValue(salesTable.lastMonthAchieved)}`}

                                    </td>
                                    <td>
                                        {salesTable.lastMonthRank < salesTable.ThisMonthRank ? (
                                            <span style={{ color: 'red' }}>
                                                <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                                {`${(salesTable.lastMonthRank ? salesTable.lastMonthRank : '-')}`}
                                            </span>
                                        ) : salesTable.lastMonthRank > salesTable.ThisMonthRank ? (
                                            <span style={{ color: 'green' }}>
                                                <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                                {`${(salesTable.lastMonthRank ? salesTable.lastMonthRank : '-')}`}
                                            </span>
                                        ) : `${(salesTable.lastMonthRank ? salesTable.lastMonthRank : '-')}`}

                                    </td>
                                    <td> {salesTable.LastMonthCampaignsCount < salesTable.ThisMonthCampaignsCount ? (
                                        <span style={{ color: 'red' }}>
                                            <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                            {salesTable.LastMonthCampaignsCount}
                                        </span>
                                    ) : salesTable.LastMonthCampaignsCount > salesTable.ThisMonthCampaignsCount ? (
                                        <span style={{ color: 'green' }}>
                                            <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                            {salesTable.LastMonthCampaignsCount}
                                        </span>
                                    ) : salesTable.LastMonthCampaignsCount}</td>



                                    <td>
                                        {salesTable.lastMonthAvg < salesTable.thisMonthAvg ? (
                                            <span style={{ color: 'red' }}>
                                                <SlIcon library="lucide" name="arrow-down" className='mr-1'></SlIcon>
                                                {`${(salesTable.lastMonthAvg)}`}
                                            </span>
                                        ) : salesTable.lastMonthAvg > salesTable.thisMonthAvg ? (
                                            <span style={{ color: 'green' }}>
                                                <SlIcon library="lucide" name="arrow-up" className='mr-1'></SlIcon>
                                                {`${(salesTable.lastMonthAvg)}`}
                                            </span>
                                        ) : `${(salesTable.lastMonthAvg)}`}

                                    </td>
                                    {salesUserType && <td>
                                        <sl-tooltip content="View" hoist>
                                            <sl-icon-button
                                                library="lucide"
                                                name="eye"
                                                style={{ backgroundColor: "transparent" }}
                                                onClick={() => { HeadDetailedView('lastMonth') }}></sl-icon-button>
                                        </sl-tooltip>
                                    </td>}

                                </tr>
                            </tbody>
                        </table> : ""} */}
                </div>

            </div>
            
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 class="mb-sm-0 font-size-18">Line Items List</h4>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header mobCH">
                    <div className="flex items-center gap-3 justify-between">

                        {(currentTab === "sales" || currentTab === "all") && (<aside className="flex items-center gap-3 justify-center mobHide">
                            <div>

                            </div>
                            {
                                ((localStorage.getItem("role") !== roles.advertiser) ) &&

                                <div>

                                    <SlSelect placeholder="Select LineItem Type" size="medium" onSlChange={typeFilterChange}>
                                        <SlOption value="all">All</SlOption>
                                        <SlOption value="Editorial"><span className="flex align-items-center gap-2"> <div className="editorial" ></div>Editorial</span></SlOption>
                                        <SlOption value="Local"><span className="flex align-items-center gap-2"> <div className="local" ></div>Local</span></SlOption>
                                        <SlOption value="DFP"><span className="flex align-items-center gap-2"> <div className="dfp" ></div>DFP</span></SlOption>
                                    </SlSelect>
                                </div>}
                            {(localStorage.getItem("role") === roles.ops) && <div>
                                <SlSelect placeholder="X filter" name="x_filter" size="medium" onSlChange={xFilterChange}>
                                    <SlIcon library="lucide" name="filter" slot="prefix"></SlIcon>
                                    <SlOption value="0">All</SlOption>
                                    <SlOption value="1">with X Value</SlOption>
                                    <SlOption value="2">without X Value</SlOption>
                                </SlSelect>
                            </div>}
                            {/* {
                                ((localStorage.getItem("role") !== roles.advertiser)) &&
                                <div>
                                    <SlSelect placeholder="Select Status" size="medium" onSlChange={status_filterChange}>
                                        <SlIcon library="lucide" name="indian-rupee" slot="prefix"></SlIcon>
                                        <SlOption value="-1">All</SlOption>
                                        <SlOption value="1">Created</SlOption>
                                        <SlOption value="6">Approved</SlOption>
                                        <SlOption value="2">Running</SlOption>
                                        <SlOption value="3">Paused</SlOption>
                                        <SlOption value="4">Completed</SlOption>
                                        <SlOption value="5">Scheduled</SlOption>
                                    </SlSelect>
                                </div>} */}
                            {((localStorage.getItem("role") !== roles.advertiser)) &&
                                <div>
                                    <SlSelect placeholder="Select Language" name="lang" size="medium" onSlChange={LanguageFilterChange}>
                                        <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                        <SlOption value="-1">All</SlOption>
                                        {
                                            languageOptions.map(item => {
                                                return <SlOption key={item.value} value={item.value}>{item.label}</SlOption>
                                            })
                                        }
                                    </SlSelect>
                                </div>}
                            {
                                langfilter !== -1 &&
                                <div>
                                    <SlSelect placeholder="Select State" name="state" size="medium" onSlChange={(e) => { StateFilterChange(e.target.value) }}>
                                        <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                        <SlOption value="-1">All</SlOption>
                                        {
                                            stateOptions.filter((item) => item.lang_id === +langfilter).map(item => {
                                                return (
                                                    <SlOption key={item.state_id} value={item.state_id}>
                                                        {item.state_name}
                                                    </SlOption>
                                                );
                                            })
                                        }
                                    </SlSelect>
                                </div>}
                            {statefilter !== -1 &&
                                <div>
                                    <SlSelect placeholder="Select District" name="district" size="medium" onSlChange={(e) => { DistrictFilterChanger(e.target.value) }}>
                                        <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                        <SlOption value="-1">All</SlOption>
                                        {
                                            districtfilter.map(item => {
                                                return (
                                                    <SlOption key={item.value.dist_id} value={item.value.dist_id}>
                                                        {item.label}
                                                    </SlOption>
                                                );
                                            })
                                        }
                                    </SlSelect>
                                </div>}

                            {
                                districtselect !== -1 &&
                                <div>
                                    <SlSelect placeholder="Select Mandal" name="mandal" size="medium" onSlChange={(e) => { MandalFilterChange(e.target.value) }}>
                                        <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                        <SlOption value="-1">All</SlOption>
                                        {
                                            mandalfilter.map(item => {
                                                return (
                                                    <SlOption key={item.value.mandal_id} value={item.value.mandal_id}>
                                                        {item.label}
                                                    </SlOption>
                                                );
                                            })
                                        }
                                    </SlSelect>
                                </div>
                            }
                             {(localStorage.getItem("role") === roles.ops) && <div>
                                <SlSelect placeholder="Team wise" name="Team wise" size="medium" value={salesTeam} onSlChange={salesTeamchange}>
        
                                    <SlOption value="All">All</SlOption>
                                    {
                                          teams.map(item => {
                                            return <SlOption key={item.value} value={item.value}>{item.label}</SlOption>
                                        })
                                    }
                                </SlSelect>
                            </div>}
                            {(localStorage.getItem("role")===roles.ops) && <div>
                                
                                <SlSelect placeholder="Category wise" name="Categor wise" size="medium" value={salesCategory}  onSlChange={salesCategoryChange}>
                                        <SlOption key="All" value="0">All</SlOption>
                                          {categories.map((category) => (
                                            <SlOption key={category.category_id} value={category.category_id}>{category.category_name}</SlOption>
                                          ))}
                                        </SlSelect>
                                
                                </div>}
                                {
                                    <div>
                                        <SlSelect placeholder="Order by Campaign Name" name="Order by Campaign name" size="medium" value={orderByCName} onSlChange={(e) => {setOrderByCName(e.target.value)}}>
                                            <SlOption value="0">None</SlOption>
                                            <SlOption value="1">Asc</SlOption>
                                            <SlOption value="2">Desc</SlOption>
                                        </SlSelect>
                                    </div>
                                }
                                <div>
                                    {Headdate.startDate && Headdate.endDate && <button className="btn btn-primary" 
                                    onClick={() =>
                                        downloadCreative(
                                          search,
                                          currentPage,
                                          status_filter,
                                          campaignType,
                                          filter_sales_ops,
                                          x_filter,
                                          target_filter,
                                          salesTeam,
                                          salesCategory,
                                          "1"
                                        )
                                      }>
                                    Download Creatives
                                    </button>}
                                </div>
                            <div>
                                {/* {localStorage.getItem("role") === roles.ops ? <SlButton variant="primary" size="medium" onClick={() => { navigate("/home/campaign/start", { state: {...result, order: {order_id: "1220231", order_type: "Editorial",company_id: 32}} }) }}>Add Campaign</SlButton> : null} */}
                            </div>
                            
                        </aside> )}
                        <div className="ml-auto">
                                <CSVLink
                                    data={downloadData.map(
                                        ({
                                            campaign_name,
                                            campaign_type,
                                            start_date,
                                            end_date,
                                            position,
                                            total_budget,
                                            daily_budget,
                                            total_imp,
                                            total_click,
                                            status,
                                            cpd,
                                            impclicks,
                                            cpc_price,
                                            cpm,
                                            location_name,
                                            sales_person_name,
                                            team,
                                            creative_type,
                                            target,adv_spent,total_spent,order_id, brand_name, category_name, filterStats, filterSpent, company_name, filterActualSpent,
                                            gst_no,
                                            campaign_id,
                                            invoice_url,
                                            rofile_url,
                                            discount_obj,
                                            new_user_type,
                                            package_number,
                                            package_weeks
                                        }) => {
                                            const startDate = formatDateWithTimeYear(start_date);
                                            const endDate = formatDateWithTimeYear(end_date);
                                            const campaign_status = fun3(status);
                                            const total =
                                                campaign_type === "CPD" ? cpd : total_budget;
                                            const daily =
                                                campaign_type === "CPD" ? cpd : daily_budget;
                                            // const imps = impclicks[0]?.total_imp ? impclicks[0]?.total_imp : 0;

                                            const imps =
                                            localStorage.getItem("role") === roles.ops
                                                    ? impclicks[0]?.total_imp
                                                        ? impclicks[0]?.total_imp
                                                        : 0
                                                    : parseInt(
                                                        impclicks[0]?.adv_total_imp
                                                            ? impclicks[0]?.adv_total_imp
                                                            : 0
                                                    );
                                            const clicks =
                                            localStorage.getItem("role") === roles.ops
                                                    ? impclicks[0]?.total_click
                                                        ? impclicks[0]?.total_click
                                                        : 0
                                                    : parseInt(
                                                        impclicks[0]?.adv_total_click
                                                            ? impclicks[0]?.adv_total_click
                                                            : 0
                                                    );
                                            const shares = impclicks[0]?.shares
                                                ? impclicks[0]?.shares
                                                : 0;
                                            const ctr =
                                                impclicks[0]?.total_click > 0 &&
                                                    impclicks[0]?.total_imp > 0
                                                    ? (
                                                        (impclicks[0].total_click /
                                                            impclicks[0].total_imp) *
                                                        100
                                                    ).toFixed(2)
                                                    : 0;
                                            const ecpm =
                                                campaign_type === "CPC" &&
                                                    impclicks[0]?.total_click > 0 &&
                                                    impclicks[0]?.total_imp > 0
                                                    ? (
                                                        ((cpc_price * impclicks[0].total_click) /
                                                            impclicks[0].total_imp) *
                                                        1000
                                                    ).toFixed(2)
                                                    : campaign_type === "CPM" &&
                                                        impclicks[0]?.total_imp > 0
                                                        ? (
                                                            ((cpm * impclicks[0].total_imp) /
                                                                1000 /
                                                                impclicks[0].total_imp) *
                                                            1000
                                                        ).toFixed(2)
                                                        : campaign_type === "CPD"
                                                            ? cpd
                                                            : 0;
                                            const advctr =
                                            impclicks[0]?.adv_total_click > 0 &&
                                                impclicks[0]?.adv_total_imp > 0
                                                ? (
                                                    (impclicks[0].adv_total_click /
                                                        impclicks[0].adv_total_imp) *
                                                    100
                                                ).toFixed(2)
                                                : 0;
                                            const advecpm =
                                                campaign_type === "CPC" &&
                                                    impclicks[0]?.adv_total_click > 0 &&
                                                    impclicks[0]?.adv_total_imp > 0
                                                    ? (
                                                        ((cpc_price * impclicks[0].adv_total_click) /
                                                            impclicks[0].adv_total_imp) *
                                                        1000
                                                    ).toFixed(2)
                                                    : campaign_type === "CPM" &&
                                                        impclicks[0]?.adv_total_imp > 0
                                                        ? (
                                                            ((cpm * impclicks[0].adv_total_imp) /
                                                                1000 /
                                                                impclicks[0].adv_total_imp) *
                                                            1000
                                                        ).toFixed(2)
                                                        : campaign_type === "CPD"
                                                            ? cpd
                                                            : 0;
                                            let obj = {
                                                campaign_name,
                                                campaign_type,
                                                start_date: startDate,
                                                end_date: endDate,
                                                position,
                                                total_budget: total,
                                                daily_budget: daily,
                                                total_imp: imps,
                                                total_click: clicks,
                                                spent: total_spent,
                                                status: campaign_status,
                                                order_id,
                                                brand_name,
                                                category_name,
                                                sales_person_name,
                                                company_name,
                                                gst_no,
                                                campaign_id,
                                                invoice_url,
                                                rofile_url,
                                                new_user_type: new_user_type === -1 ? "Main User" : BrandsTypes.find(i => i.value === new_user_type)?.label || "",
                                                package: package_number && package_weeks ? `${package_number} of ${package_weeks}` : ''
                                            };
                                            if (
                                                localStorage.getItem("role") === roles.ops
                                            ) {
                                                obj.shares = shares;
                                                obj.ctr_percent = ctr;
                                                obj.ecpm_cpd = ecpm;
                                                obj.location_name = location_name;
                                                obj.team = team;
                                                obj.creative_type = creative_type;
                                                obj.adv_total_imp = impclicks[0]?.adv_total_imp
                                                obj.adv_total_click = impclicks[0]?.adv_total_click
                                                obj.adv_spent = adv_spent
                                                obj.adv_ctr = advctr
                                                obj.adv_ecpm = advecpm
                                                obj.discount_per = discount_obj?.discount_no || '-'
                                                obj.discount_amount = discount_obj?.discountPrice || '-'
                                                obj.actual_price = discount_obj?.actualPrice || '-'
                                            }
                                            if(localStorage.getItem('role') === roles.financer || localStorage.getItem('role') === roles.ops){
                                                obj.filterImps = filterStats?.adv_total_imp ? filterStats?.adv_total_imp : 0;
                                                obj.filterClicks = filterStats?.adv_total_click ? filterStats?.adv_total_click : 0;
                                                obj.filterSpent = filterSpent

                                                if(localStorage.getItem('role') === roles.ops){
                                                    obj.filterActualImps = filterStats?.total_imp ? filterStats?.total_imp : 0;
                                                    obj.filterActualClicks = filterStats?.total_click ? filterStats?.total_click : 0;
                                                    obj.filterActualSpent = filterActualSpent
                                                }

                                            }
                                            let resultTarget = "";
                                            Object.keys(target).map((key) => {
                                                resultTarget =
                                                    resultTarget + `${key} : ${target[key]} \,`;
                                            });
                                            obj.target = resultTarget;
                                            return obj;
                                        }
                                    )}
                                    headers={csvHeaders}
                                    filename={"lineitems_reports.csv"}
                                    ref={csvLinkRef} // Assign the ref to the CSVLink component
                                ></CSVLink>

                                {downloadLoader ? (
                                    <TableLoader />
                                ) : (
                                    <SlTooltip content="Download LineItem Reports">
                                        <SlIcon
                                            library="lucide"
                                            name="download"
                                            className="w-6 h-6"
                                            onClick={() => {
                                                downloadReport(filter_sales_ops, search, status_filter, Headdate, campaignType, x_filter, target_filter, currentTab, salesTeam,salesCategory)
                                            }}
                                        ></SlIcon>
                                    </SlTooltip>
                                )}
                            </div>
                    <img src={filterSvg} className="mobileOnly w-6 " onClick={() => setShowFilter(true)} alt="filter" ></img>
                    </div>
                </div>

                <div className="card-body cc-body">
                    <SlTabGroup onSlTabShow={handleTabActivate}>
                        {localStorage.getItem("role") !== roles.financer && <SlTab slot="nav" panel="sales" onClick={() => handleTabClick("sales")}>
                            {localStorage.getItem("name")}
                        </SlTab>}
                        {
                            localStorage.getItem("role") !== roles.advertiser &&
                            <>
                                <SlTab slot="nav" panel="all" onClick={() => handleTabClick("all")}>
                                    {SALES?.label ? SALES.label : "All"}
                                </SlTab>
                                
                            </>}

                        <SlTabPanel name="all">
                            
                            <div className="cc-padding">
                                <div className="overflow-x-auto mb-4" >
                                    <LineItemsTableView data={data} loader={loader} dateFilter={localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.ops ?  ( Headdate?.startDate ? Headdate : null) : null}/>
                                </div>
                                <div className="flex justify-end">
                                    {totalPages > 1 && <Paginator
                                        pageCount={totalPages}
                                        handlePageClick={handlePageClick}
                                        forcePage={currentPage}
                                    />
                                    }
                                </div>


                            </div >

                        </SlTabPanel >
                        <SlTabPanel name="sales">
                        <div className="cc-padding">
                                <div className="overflow-x-auto mb-4" >
                                    <LineItemsTableView  data={data} loader={loader}  dateFilter={localStorage.getItem("role") === roles.financer ?  ( Headdate?.startDate ? Headdate : null) : null}/>
                                </div>
                                <div className="flex justify-end">
                                    {totalPages > 1 && <Paginator
                                        pageCount={totalPages}
                                        handlePageClick={handlePageClick}
                                        forcePage={currentPage}
                                    />
                                    }
                                </div>
                            </div >
                        </SlTabPanel>
                        {/* {headViewData && Object.keys(headViewData).length > 0 && <SlDrawer
                            label={`Detailed View of ${headViewMonthFlag}`}
                            style={{ '--size': '50vw' }}
                            open={Object.keys(headViewData).length > 0}
                            onSlAfterHide={() => { setHeadViewData({}); setHeadViewMonthFlag("") }}
                        >
                            <div className="overflow-x-auto">
                                {headViewData.headData?.length ? <>
                                    <h2>Heads</h2>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <td>Name</td>
                                                <td>I/O RECEIVED</td>
                                                <td>DELIVERED</td>
                                                <td>TARGET</td>
                                                <td>ACHIEVED</td>
                                                <td>RANK</td>
                                                <td>CAMPAIGNS</td>
                                                <td>AVG</td>
                                            </tr>
                                        </thead>
                                        {headViewData.headData?.length ? <tbody>
                                            {headViewData.headData?.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{capitalizeFirstLetter(item.value.name)}</td>
                                                        <td>{`₹${formatSpentValue(item.value.monthRoCPD)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.delivered)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.target)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.monthAchieved)}`}</td>
                                                        <td>{item.value.rank}</td>
                                                        <td>{item.value.campaignCount}</td>
                                                        <td>{item.value.monthAvg}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody> : <NoDataFound></NoDataFound>}
                                    </table>
                                </> : null}
                                {headViewData.nationRegionHeadsData?.length ? <>
                                    <h2>National Region Heads</h2>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <td>Name</td>
                                                <td>I/O RECEIVED</td>
                                                <td>DELIVERED</td>
                                                <td>TARGET</td>
                                                <td>ACHIEVED</td>
                                                <td>RANK</td>
                                                <td>CAMPAIGNS</td>
                                                <td>AVG</td>
                                            </tr>
                                        </thead>
                                        {headViewData.nationRegionHeadsData?.length ? <tbody>
                                            {headViewData.nationRegionHeadsData?.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{capitalizeFirstLetter(item.value.name)}</td>
                                                        <td>{`₹${formatSpentValue(item.value.monthRoCPD)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.delivered)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.target)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.monthAchieved)}`}</td>
                                                        <td>{item.value.rank}</td>
                                                        <td>{item.value.campaignCount}</td>
                                                        <td>{item.value.monthAvg}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody> : <NoDataFound></NoDataFound>}
                                    </table>
                                </> : null}
                                {headViewData.nationRegularData?.length ? <>
                                    <h2>National Sales</h2>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <td>Name</td>
                                                <td>I/O RECEIVED</td>
                                                <td>DELIVERED</td>
                                                <td>TARGET</td>
                                                <td>ACHIEVED</td>
                                                <td>RANK</td>
                                                <td>CAMPAIGNS</td>
                                                <td>AVG</td>
                                            </tr>
                                        </thead>
                                        {headViewData.nationRegularData?.length ? <tbody>
                                            {headViewData.nationRegularData?.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{capitalizeFirstLetter(item.value.name)}</td>
                                                        <td>{`₹${formatSpentValue(item.value.monthRoCPD)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.delivered)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.target)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.monthAchieved)}`}</td>
                                                        <td>{item.value.rank}</td>
                                                        <td>{item.value.campaignCount}</td>
                                                        <td>{item.value.monthAvg}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody> : <NoDataFound></NoDataFound>}
                                    </table>
                                </> : null}
                                {headViewData.localRegularData?.length ? <>
                                    <h2>Local Sales</h2>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <td>Name</td>
                                                <td>I/O RECEIVED</td>
                                                <td>DELIVERED</td>
                                                <td>TARGET</td>
                                                <td>ACHIEVED</td>
                                                <td>RANK</td>
                                                <td>CAMPAIGNS</td>
                                                <td>AVG</td>
                                            </tr>
                                        </thead>
                                        {headViewData.localRegularData?.length ? <tbody>
                                            {headViewData.localRegularData?.map((item) => {
                                                return (
                                                    <tr>
                                                        <td>{capitalizeFirstLetter(item.value.name)}</td>
                                                        <td>{`₹${formatSpentValue(item.value.monthRoCPD)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.delivered)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.target)}`}</td>
                                                        <td>{`₹${formatSpentValue(item.value.monthAchieved)}`}</td>
                                                        <td>{item.value.rank}</td>
                                                        <td>{item.value.campaignCount}</td>
                                                        <td>{item.value.monthAvg}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody> : <NoDataFound></NoDataFound>}
                                    </table>
                                </> : null}
                            </div>
                        </SlDrawer>} */}
                    </SlTabGroup >
                </div >
            </div >
            <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={()=>{}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
        <h3 className="mb-3">Apply Filters</h3>
        <hr></hr>
        <div className="flex items-center gap-3 flex-wrap justify-between">
{(currentTab === "sales" || currentTab === "all") && (<aside className="flex items-center gap-3 justify-center  flex-wrap ">
    {
        ((localStorage.getItem("role") !== roles.advertiser) ) &&

        <div className="w-full">

            <SlSelect placeholder="Select LineItem Type" size="medium" onSlChange={typeFilterChange}>
                <SlOption value="all">All</SlOption>
                <SlOption value="Editorial"><span className="flex align-items-center gap-2"> <div className="editorial" ></div>Editorial</span></SlOption>
                <SlOption value="Local"><span className="flex align-items-center gap-2"> <div className="local" ></div>Local</span></SlOption>
                <SlOption value="DFP"><span className="flex align-items-center gap-2"> <div className="dfp" ></div>DFP</span></SlOption>
            </SlSelect>
        </div>}
    {(localStorage.getItem("role") === roles.ops) && <div className="w-full">
        <SlSelect placeholder="X filter" name="x_filter" size="medium" onSlChange={xFilterChange}>
            <SlIcon library="lucide" name="filter" slot="prefix"></SlIcon>
            <SlOption value="0">All</SlOption>
            <SlOption value="1">with X Value</SlOption>
            <SlOption value="2">without X Value</SlOption>
        </SlSelect>
    </div>}
    {/* {
        ((localStorage.getItem("role") !== roles.advertiser)) &&
        <div>
            <SlSelect placeholder="Select Status" size="medium" onSlChange={status_filterChange}>
                <SlIcon library="lucide" name="indian-rupee" slot="prefix"></SlIcon>
                <SlOption value="-1">All</SlOption>
                <SlOption value="1">Created</SlOption>
                <SlOption value="6">Approved</SlOption>
                <SlOption value="2">Running</SlOption>
                <SlOption value="3">Paused</SlOption>
                <SlOption value="4">Completed</SlOption>
                <SlOption value="5">Scheduled</SlOption>
            </SlSelect>
        </div>} */}
    {((localStorage.getItem("role") !== roles.advertiser)) &&
        <div className="w-full">
            <SlSelect placeholder="Select Language" name="lang" size="medium" onSlChange={LanguageFilterChange}>
                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                <SlOption value="-1">All</SlOption>
                {
                    languageOptions.map(item => {
                        return <SlOption key={item.value} value={item.value}>{item.label}</SlOption>
                    })
                }
            </SlSelect>
        </div>}
    {
        langfilter !== -1 &&
        <div className="w-full">
            <SlSelect placeholder="Select State" name="state" size="medium" onSlChange={(e) => { StateFilterChange(e.target.value) }}>
                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                <SlOption value="-1">All</SlOption>
                {
                    stateOptions.filter((item) => item.lang_id === +langfilter).map(item => {
                        return (
                            <SlOption key={item.state_id} value={item.state_id}>
                                {item.state_name}
                            </SlOption>
                        );
                    })
                }
            </SlSelect>
        </div>}
    {statefilter !== -1 &&
        <div className="w-full">
            <SlSelect placeholder="Select District" name="district" size="medium" onSlChange={(e) => { DistrictFilterChanger(e.target.value) }}>
                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                <SlOption value="-1">All</SlOption>
                {
                    districtfilter.map(item => {
                        return (
                            <SlOption key={item.value.dist_id} value={item.value.dist_id}>
                                {item.label}
                            </SlOption>
                        );
                    })
                }
            </SlSelect>
        </div>}

    {
        districtselect !== -1 &&
        <div className="w-full">
            <SlSelect placeholder="Select Mandal" name="mandal" size="medium" onSlChange={(e) => { MandalFilterChange(e.target.value) }}>
                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                <SlOption value="-1">All</SlOption>
                {
                    mandalfilter.map(item => {
                        return (
                            <SlOption key={item.value.mandal_id} value={item.value.mandal_id}>
                                {item.label}
                            </SlOption>
                        );
                    })
                }
            </SlSelect>
        </div>
    }
      {(localStorage.getItem("role") === roles.ops) && <div className="w-full">
                                <SlSelect placeholder="Team wise" name="Team wise" size="medium" onSlChange={xFilterChange}>
        
                                    <SlOption value="0">All</SlOption>
                                    {
                                          teams.map(item => {
                                            return <SlOption key={item.value} value={item.value}>{item.label}</SlOption>
                                        })
                                    }
                                </SlSelect>
                            </div>}
                            {(localStorage.getItem("role")===roles.ops) && <div className="w-full">
                                
                                <SlSelect placeholder="Category wise" name="Category wise" size="medium"  onSlChange={xFilterChange}>
                                        <SlOption key="All" value="0">All</SlOption>
                                          {categories.map((category) => (
                                            <SlOption key={category.category_name} value={category.category_name.replace(/ /g, '_')}>{category.category_name}</SlOption>
                                          ))}
                                        </SlSelect>
                                
                                </div>} 
                                <div className="w-full">
                                    <button type="submit" className="btn btn-primary w-full">
                                    Download Creatives
                                    </button>
                                </div>
    <div>
        {/* {localStorage.getItem("role") === roles.ops ? <SlButton variant="primary" size="medium" onClick={() => { navigate("/home/campaign/start", { state: {...result, order: {order_id: "1220231", order_type: "Editorial",company_id: 32}} }) }}>Add Campaign</SlButton> : null} */}
    </div>
</aside>)}
</div>
        <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
        </>
    )

}

export default LineItems
